import { Component } from "@angular/core";
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { BaseComponent } from "../../../core/base-component/basecomponent.component";
import { MyDeqErrorHandler } from "../../../core/errorHandler";
import { AppService } from "../../../service/app.service";
import { Utils } from "../../../shared/Utils";
import { PagecontentSearchCriteriaPage } from "./search-criteria.resourcebundle";

@Component({
  selector: "search-criteria",
  templateUrl: "./search-criteria.component.html",
})
export class SearchCriteriaComponent extends BaseComponent {
  pageForm: UntypedFormGroup;
  errorsList: any[] = [];
  constructor(
    protected activatedRoute: ActivatedRoute,
    protected formBuilder: UntypedFormBuilder,
    public utils: Utils,
    protected appService: AppService,
    protected errorHandler: MyDeqErrorHandler,
    private router: Router
  ) {
    super() ;

    this.pageForm = this.createForm();
    let pageContent = new PagecontentSearchCriteriaPage();

    this.pageText = this.utils.getPathSpecificText(
      pageContent.PAGE_TEXT["base"],
      pageContent.PAGE_TEXT["searchcriteria"]
    );
  }

  createForm(): UntypedFormGroup {
    return this.formBuilder.group({
      ltf: new UntypedFormControl(null),
      company: new UntypedFormControl(null),
      facility: new UntypedFormControl(null),
      county: new UntypedFormControl(null),
    });
  }

  searchData(formData: any) {
    let qParams = {};

    if (formData.ltf) {
      qParams["ltfid"] = formData.ltf;
    }

    if (formData.company) {
      qParams["companyname"] = formData.company;
    }

    if (formData.facility) {
      qParams["facilityname"] = formData.facility;
    }

    if (formData.county && formData.county !== "-1") {
      qParams["facilitycounty"] = formData.county;
    }

    // Always go to approved-list — it shows the 5-column table.
    // If only one result comes back, clicking VIEW from there goes to the detail accordion.
    this.router.navigate(["/cgp", "approved-list"], { queryParams: qParams });
  }

  viewAll() {
    this.router.navigate(["/cgp", "approved-list"]);
  }
}
